import { render, staticRenderFns } from "./AppRolesCrud.vue?vue&type=template&id=5fe60c32&scoped=true&"
import script from "./AppRolesCrud.vue?vue&type=script&lang=js&"
export * from "./AppRolesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe60c32",
  null
  
)

export default component.exports